import React from 'react';

import { Component as LineItemCell } from './LineItemCell.jsx';
import * as ListContainer from '../common/ListContainer.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

function LineItems(props) { return <ListContainer.Component cellComponent={LineItemCell} records={Utilities.Inventory.getRecords(props)} {...props} /> }

const TypeConfig = {
    panel: {
        block: () => ListContainer.TypeConfig.panel.block(Name.Content.ConsignmentLineItem),
        style: ListContainer.TypeConfig.panel.style,
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Edition Info', name: Token.Inventory.Edition, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Edition, config, Name.Block.Inventory.Meta) },
                    { display: 'Created Date', name: Token.Date, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Date, config, Name.Block.Inventory.Meta) },
                    { display: 'Medium', name: Token.Inventory.Medium, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Medium, config, Name.Block.Inventory.Meta) },
                    { display: 'Dimensions', name: Token.Inventory.Dimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Dimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Number', name: Token.Inventory.Number, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Number, config, Name.Block.Inventory.Meta) },
                    { display: 'SKU', name: Token.Inventory.SKU, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.SKU, config, Name.Block.Inventory.Meta) },
                    { display: 'Location', name: Token.Inventory.Location, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Location, config, Name.Block.Inventory.Meta) },
                    { display: 'Acquisition Date', name: Token.Inventory.AcquisitionDate, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AcquisitionDate, config, Name.Block.Inventory.Meta) },
                    { display: 'Retail Price', name: Token.Total.Retail, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Total.Retail, config, Name.Block.Inventory.Meta) },
                    { display: 'Consignment Cost', name: Token.Total.Consignment, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Total.Consignment, config, Name.Block.Inventory.Meta) }
                ],
                visible: () => false
            };
        }
    }
}

export {
    LineItems as Component,
    TypeConfig
}